import wixAnimations from 'wix-animations';
const arrow01 = wixAnimations.timeline ({ repeat: -1, yoyo: true, repeatDelay: 3000} )


$w.onReady(function () {

arrow01
.add($w('#mainarrow01'),{ scale: 1, y: 0, x: 19, duration: 800, rotate: 0, opacity: 1, easing:'easeInOutQuad' })
.add($w('#mainarrow01'),{ scale: 1, y: 0, x: 0, duration: 800, rotate: 0, opacity: 1, easing:'easeInOutQuad' })

.play()
});